import { render } from "./VideoPlayerContainer.vue?vue&type=template&id=4cb31b36"
import script from "./VideoPlayerContainer.vue?vue&type=script&lang=js"
export * from "./VideoPlayerContainer.vue?vue&type=script&lang=js"

import "./VideoPlayerContainer.vue?vue&type=style&index=0&id=4cb31b36&lang=css"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__